import React, { useState, useReducer, useEffect, useRef } from "react";

// Components imports
import CategoriesContainer from "../../components/Categories/CategoriesContainer";
import CategoriesProcessorsNavigation from "../../components/common/CategoriesProcessorsNavigation";

// Scss imports
import css from "./Categories.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { getFruits } from "../../redux/actions/getFruitsAction";
import {
  getCategories,
  addCategory,
  updateCategory,
  getActiveCategories,
  resetStore,
  manuallyTrigerMessage,
} from "../../redux/actions/categoriesActions";

import { useHistory } from "react-router-dom";

interface CategoriesProps {}

const Categories: React.FC<CategoriesProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const currentUserRole = useSelector(
    (state: any) => state.currentUser.currentUserData.role
  );

  const addCategoryStatus = useSelector(
    (state: any) => state.allCategories.addCategory
  );

  const [userInput, setUserInput] = useState({
    baseNumber: null,
    name: "",
    shelfLife: null,
  });

  // Setting up form
  const [form, setForm] = useState({
    baseNumber: userInput.baseNumber,
    name: userInput.name,
    shelfLife: userInput.shelfLife,
  });

  // State for hanling state of show all / show just active categories
  const [showAllCategories, setShowAllCategories] = useState(false);

  const [parent, setParent]: any = useState();

  // On input change set input name and value to text that user added
  const handleChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    //setUserInput({ [name]: newValue });
    setUserInput((state) => ({ ...state, [e.target.name]: e.target.value }));
  };

  const categories = useSelector(
    (state: any) => state.allCategories.categories
  );

  const activeCategories = useSelector(
    (state: any) => state.allCategories.categoriesActive
  );

  const [renderedNewCategoryItem, setRenderedNewCategoryItem] = useState(false);

  const fruits = useSelector((state: any) => state.allFruits);

  // Clean object before update function
  const clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === "" ||
        //obj[propName] === 0 ||
        obj[propName] === null ||
        obj[propName] === undefined
      ) {
        delete obj[propName];
      }
    }
    return obj;
  };

  // Create processor function
  const createCategory = (e) => {
    setParent(e.target.parentNode);
    dispatch(
      addCategory(
        {
          baseNumber: userInput.baseNumber,
          name: userInput.name,
          shelfLife: userInput.shelfLife,
        },
        history
      )
    );
    if (addCategoryStatus === "fail") {
      setRenderedNewCategoryItem(true);
      setTimeout(() => {
        dispatch(manuallyTrigerMessage(""));
      }, 3000);
    }
    // If add processor status === 'sucess' remove add processor box
  };
  // Edit processor function
  const editCategory = (e) => {
    let divArray: any = [];
    const inputValues: any = [];
    const buttonClicked = e.target;
    const clickedContainer: HTMLElement = buttonClicked.parentNode;
    const formElement: Element[] = Array.from(clickedContainer.children);
    divArray = [formElement[0], formElement[1], formElement[2]];

    divArray.forEach((divElement) => {
      const input: any = divElement.children[2].children[0];
      inputValues.push(input.value);
    });

    const id: any = clickedContainer.dataset.id;

    dispatch(
      updateCategory(
        clean({
          baseNumber: inputValues[0],
          name: inputValues[1],
          shelfLife: inputValues[2],
        }),
        id
      )
    );

    if (addCategoryStatus === "fail") {
      setRenderedNewCategoryItem(true);
      setTimeout(() => {
        dispatch(manuallyTrigerMessage(""));
      }, 3000);
    }
  };

  useEffect(() => {
    dispatch(resetStore());
    setRenderedNewCategoryItem(false);
  }, [dispatch]);

  useEffect(() => {
    if (addCategoryStatus === "fail") {
      setRenderedNewCategoryItem(true);
      setTimeout(() => {
        dispatch(manuallyTrigerMessage(""));
      }, 3000);
    }
    if (addCategoryStatus === "sucess") {
      setRenderedNewCategoryItem(false);
      //const el: any = document.getElementById("addItem");
      if (parent) {
        parent.parentNode.parentNode.remove();
        userInput.baseNumber = null;
        userInput.name = "";
        userInput.shelfLife = null;
      }
      dispatch(getActiveCategories());
      dispatch(getCategories());
    }
  }, [addCategoryStatus, parent]);

  useEffect(() => {
    setRenderedNewCategoryItem(false);
  }, []);

  useEffect(() => {
    dispatch(getActiveCategories());
    //req dispatch(getCategories());
  }, [dispatch]);

  return (
    <div className={css.container}>
      {/*<button onClick={() => dispatch(getCategories([{ anna: "" }]))}>
        {fruits[0].genus}
	</button>*/}
      <h1>Унесите категорије</h1>
      <CategoriesProcessorsNavigation
        processorButtonClickHandler={() =>
          setShowAllCategories((prevState) => !prevState)
        }
        showAllText={
          showAllCategories ? "Активне категорије" : "Све категорије"
        }
      />

      {showAllCategories ? (
        <CategoriesContainer
          categories={categories.data}
          createCategory={createCategory}
          editCategory={editCategory}
          renderedNewCategoryItem={renderedNewCategoryItem}
          setRenderedNewCategoryItem={setRenderedNewCategoryItem}
          baseNumber={userInput.baseNumber}
          name={userInput.name}
          shelfLife={userInput.shelfLife}
          handleChange={handleChange}
          addCategoryStatus={addCategoryStatus}
          showAllCategories={showAllCategories}
          setUserInput={setUserInput}
        />
      ) : (
        <CategoriesContainer
          categories={activeCategories.data}
          createCategory={createCategory}
          editCategory={editCategory}
          renderedNewCategoryItem={renderedNewCategoryItem}
          setRenderedNewCategoryItem={setRenderedNewCategoryItem}
          baseNumber={userInput.baseNumber}
          name={userInput.name}
          shelfLife={userInput.shelfLife}
          handleChange={handleChange}
          addCategoryStatus={addCategoryStatus}
          showAllCategories={showAllCategories}
          setUserInput={setUserInput}
        />
      )}
    </div>
  );
};

export default Categories;
